export default "/images/vendor/flag-icon-css/flags/4x3/id.svg?e2afd171e6a62816237b8c39bdb26ccc";